import moment from 'moment';
import {keyCodes} from '@pb/kit-util-key-codes';
import {onlyDigit} from './only-digit';
import {formattedYear} from './formatted-year';

const dataSeparatorsCode = [
    keyCodes.KEY_SUBTRACT,
    keyCodes.KEY_DIVIDE,
    keyCodes.KEY_SUBTRACT_IE,
] as const;

const replaceDateSeparators = (value: string) =>
    value.replaceAll(
        new RegExp(dataSeparatorsCode.join('|'), 'g'),
        keyCodes.KEY_SUBTRACT,
    );

export const convertNumberToDate = (value: string, dateFormat?: string): ReturnType<typeof moment> => {
    if (onlyDigit(value)) {
        if (value.match(/^\d{4}$/)) {
            return moment(value, 'YYYY');
        }

        const processedYearValue =
            dateFormat === 'YYYY' ? formattedYear(value) : value;
        return moment(processedYearValue, dateFormat);
    } else if (value.match(/^\d{1,2}[/-]\d{1,2}$/)) {
        return moment(value, 'MM-YY');
    } else if (value.match(/^(?:\d{1,2}[/-]){2}\d{1,2}$/)) {
        return moment(
            replaceDateSeparators(value),
            dateFormat ? dateFormat.replace('YYYY', 'YY') : undefined,
        );
    }

    return moment(replaceDateSeparators(value), dateFormat);
};
